/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProjectSummary { 
    id?: number | null;
    name?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    isActive?: boolean | null;
    notes?: string | null;
    numSchools?: number | null;
    numDevices?: number | null;
    numUsers?: number | null;
}

